import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtension = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M8.75 1.75a2.5 2.5 0 0 0-2.5 2.5h-2.5a2 2 0 0 0-2 2v2.5a2.5 2.5 0 0 1 0 5v2.5a2 2 0 0 0 2 2h2.5a2.5 2.5 0 0 1 5 0h2.5a2 2 0 0 0 2-2v-2.5a2.5 2.5 0 0 0 0-5v-2.5a2 2 0 0 0-2-2h-2.5a2.5 2.5 0 0 0-2.5-2.5Z"
	})]
});
const ForwardRef = forwardRef(SvgExtension);
export { ForwardRef as ReactComponent };
